import { mapState, mapActions } from 'pinia';
import DuoCodeReviewSystemNote from 'ee_component/vue_shared/components/notes/duo_code_review_system_note.vue';
import { __ } from '~/locale';
import PlaceholderNote from '~/vue_shared/components/notes/placeholder_note.vue';
import PlaceholderSystemNote from '~/vue_shared/components/notes/placeholder_system_note.vue';
import SystemNote from '~/vue_shared/components/notes/system_note.vue';
import { FILE_DIFF_POSITION_TYPE } from '~/diffs/constants';
import { useNotes } from '~/notes/store/legacy_notes';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
import { SYSTEM_NOTE } from '../constants';
import { shouldRenderAsDuoSystemNote } from '../utils';
import DiscussionNotesRepliesWrapper from './discussion_notes_replies_wrapper.vue';
import NoteEditedText from './note_edited_text.vue';
import NoteableNote from './noteable_note.vue';
import ToggleRepliesWidget from './toggle_replies_widget.vue';
export default {
    name: 'DiscussionNotes',
    components: {
        ToggleRepliesWidget,
        NoteEditedText,
        DiscussionNotesRepliesWrapper
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        discussion: {
            type: Object,
            required: true
        },
        isExpanded: {
            type: Boolean,
            required: false,
            default: false
        },
        diffLine: {
            type: Object,
            required: false,
            default: null
        },
        line: {
            type: Object,
            required: false,
            default: null
        },
        shouldGroupReplies: {
            type: Boolean,
            required: false,
            default: false
        },
        helpPagePath: {
            type: String,
            required: false,
            default: ''
        },
        isOverviewTab: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'delete-note',
        'start-replying'
    ],
    computed: {
        ...mapState(useNotes, [
            'userCanReply'
        ]),
        hasReplies () {
            return Boolean(this.replies.length);
        },
        replies () {
            return this.discussion.notes.slice(1);
        },
        firstNote () {
            return this.discussion.notes.slice(0, 1)[0];
        },
        resolvedText () {
            return this.discussion.resolved_by_push ? __('Automatically resolved') : __('Resolved');
        },
        commit () {
            if (!this.discussion.for_commit) {
                return null;
            }
            return {
                id: this.discussion.commit_id,
                url: this.discussion.discussion_path
            };
        },
        isDiscussionInternal () {
            return this.discussion.notes[0]?.internal;
        },
        isFileDiscussion () {
            return this.discussion.position?.position_type === FILE_DIFF_POSITION_TYPE;
        }
    },
    methods: {
        ...mapActions(useNotes, [
            'toggleDiscussion',
            'setSelectedCommentPositionHover'
        ]),
        componentName (note) {
            if (note.isPlaceholderNote) {
                if (note.placeholderType === SYSTEM_NOTE) {
                    return PlaceholderSystemNote;
                }
                return PlaceholderNote;
            }
            if (note.system) {
                return shouldRenderAsDuoSystemNote(note) ? DuoCodeReviewSystemNote : SystemNote;
            }
            return NoteableNote;
        },
        componentData (note) {
            return note.isPlaceholderNote ? note.notes[0] : note;
        },
        handleMouseEnter (discussion) {
            if (discussion.position) {
                this.setSelectedCommentPositionHover(discussion.position.line_range);
            }
        },
        handleMouseLeave (discussion) {
            // Even though position isn't used here we still don't want to unnecessarily call a mutation
            // The lack of position tells us that highlighting is irrelevant in this context
            if (discussion.position) {
                this.setSelectedCommentPositionHover();
            }
        }
    }
};
